import React from "react";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import checkmark from "../../assets/images/checkmark.png";
import TopLogoCat from "../../components/layout/TopLogoCat";
import SuccessStyle from "../../assets/images/success-style.png";

export default function MyPointSuccessCat(props) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { title, points, listDetail = [] } = props;
  const { open, toPage, hasStamp, countStamp } = props;
  console.log("props >>", props);
  function DetailInfo(title, data) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={3}>
          {title}:
        </Grid>
        {data ? (
          <Grid item xs={9} className="text-end">
            {data}
          </Grid>
        ) : (
          <Grid item xs={9} className="text-end">
            -
          </Grid>
        )}
      </Grid>
    );
  }

  function gotoStampPage() {
    navigate("/my-point-stamp-cat");
    // navigate(-1);
    // setTimeout(() => {
    //   navigate("/my-point-stamp");
    // }, 10);
  }

  const isOpen = open ?? true;
  if (isOpen) {
    return (
      <div className="fixed h-screen w-screen z-10">
        <TopLogoCat />
        <div
          id="get-point-success"
          className="gradientBgGreen py-[20px] px-[20px]"
          style={{ minHeight: "calc(100vh - 60px)" }}
        >
          <img
            src={SuccessStyle}
            alt="logo"
            style={{ width: "70%", float: "right" }}
            className="mt-[-20px] mr-[-20px]"
          />
          <div className="mt-[40px] w-full px-[42px]" style={{
            position: "fixed",
            left: "50%",
            transform: "translate(-50%, 0)"
          }}>
            <div className="bHead">
              <div className="flex justify-center">
                <img
                  className="mx-auto"
                  src={checkmark}
                  alt=""
                  width="52px"
                  height="52px"
                />
              </div>

              <p className="text-center text-white text-[36px]">{title}</p>
              {hasStamp && (
                <p className="text-center text-white text-[24px]">
                  ยินดีด้วย! คุณได้รับแสตมป์ 1 ดวง
                </p>
              )}
              <div id="pStampSuccessMain">
                <div className="bg-darkGreen pPoint">
                  <div className="text-white text-center">
                    <p className="text-xl leading-tight mb-[2px]">
                      Coin ที่ได้รับ
                    </p>
                    <p className="text-[52px] leading-9 ">
                      {points} {hasStamp ? <br /> : <></>}{" "}
                      <span className="text-[36px]">คะแนน</span>
                    </p>
                  </div>
                </div>
                {hasStamp ? (
                  <div className="pStampSuccessCat">
                    <p className="tStamp">แสตมป์ที่คุณได้รับ</p>
                    {/* data-item="1" ใส่ได้ 1-12  ตาม CountStamp*/}
                    <i className="bImgStamp" data-item={countStamp}></i>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="text-white text-xl mt-[16px]">
                <p style={{ fontSize: "24px" }}>รายละเอียด</p>
                <div className="py-3">
                  <hr className="opacity-100 border-blue" />
                </div>

                <div className="">
                  {listDetail.map((item) => DetailInfo(item.name, item.value))}
                </div>
              </div>
            </div>



            <div className="bFoot">
              <p className="text-left text-white text-[16px] leading-[84%] my-[25%]">
                *คุณสามารถร่วมกิจกรรมสแกนรับพ้อยท์ได้เดือนละครั้งเท่านั้น
              </p>
              <button
                onClick={() => {
                  navigate(toPage);
                }}
                className="btn _outline green w-full !border-[#FFF] mb-[12px]"
              >
                เสร็จสิ้น
              </button>
              {hasStamp &&
                <button
                  className="btn _outline transparent w-full"
                  onClick={gotoStampPage}
                >
                  ไปยังอัลบั้มแสตมป์ของฉัน
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <></>;
}
